import React, { Component } from 'react';
import { connect } from 'react-redux'
import {withRouter} from "react-router-dom";
import {toast} from "react-toastify";
import validator from "validator";

import {setGiftRecipient} from '../Actions'

class Page extends Component {
  componentDidMount() {
    const requesterEmail = this.props.match.params.requesterEmail || '';
    if(!requesterEmail || !validator.isEmail(requesterEmail)) {
      toast.info('Please enter a valid gift recipient email address');
      return this.props.history.push('/');
    }

    this.props.dispatch(setGiftRecipient({
      recipientEmail: requesterEmail
    }));

    return this.props.history.push('/budget');
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps)(withRouter(Page));


// WEBPACK FOOTER //
// ./src/Pages/FulfillPage.js